import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Body1, Body2, Caption } from '@xo-union/tk-ui-typography';
import Icon from '@xo-union/tk-component-icons';
import AnalyticsStore from '../../../../../models/analytics-store';

import styles from './task-component.scss';

export const TaskComponent = ({
  title,
  content,
  onClick,
  className,
  dataTestid,
  ariaLabel,
  footer,
  analyticsStore,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      data-testid={dataTestid}
      className={classnames(styles.task, className)}
      role="link"
      onClick={() => onClick(analyticsStore)}
    >
      <div>
        <Body1 bold>{title}</Body1>
        <Body2>{content}</Body2>
        {footer && <Caption>{footer}</Caption>}
      </div>
      <Icon name="arrow_right_2" className={styles.infoCardIcon} size="lg" />
    </button>
  );
};

TaskComponent.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
};

export default TaskComponent;
